<script setup lang="ts">
import { locale_float } from '~/types/shared'

const props = defineProps<{
	row: any
}>()
</script>

<template>
	<div>
		<div v-if="row.ax_data?.decrypted_result?.transaction?.localCurrencyAmt && row.ax_data?.decrypted_result?.transaction?.localCurrency">
			<span class="font-mono text-zinc-800 dark:text-zinc-300">
			{{ locale_float(Number(row.ax_data?.decrypted_result?.transaction?.localCurrencyAmt || 0) + Number(row.ax_data?.decrypted_result?.transaction?.feeAmount || 0)) }}
			{{ row.ax_data?.decrypted_result?.transaction?.localCurrency }}</span>
		</div>

		<div v-else-if="row.slug == 'ax_card_recharge_result'">
			<span class="font-mono text-zinc-800 dark:text-zinc-300">{{ locale_float(row.ax_data?.decrypted_result?.receiveAmount) }} {{ row.ax_data?.decrypted_result?.currency }}</span>
		</div>

		<div v-else-if="row.ax_data?.decrypted_result?.amount && row.ax_data?.decrypted_result?.currency">
			<span class="font-mono text-zinc-800 dark:text-zinc-300">{{ locale_float(row.ax_data?.decrypted_result?.amount) }} {{ row.ax_data?.decrypted_result?.currency }}</span>
		</div>

		<div v-else-if="row.amount">
			<span class="font-mono text-zinc-800 dark:text-zinc-300">{{ locale_float(row.amount) }} {{ row.amount_currency?.toUpperCase() || (row.slug.includes('usdt') ? 'USDT' : '') }}</span>
		</div>

		<div v-else-if="row.deposit_amount">
			<span class="font-mono text-zinc-800 dark:text-zinc-300">{{ locale_float(row.deposit_amount) }} {{ row.amount_currency?.toUpperCase() || (row.slug.includes('usdt') ? 'USDT' : 'USD') }}</span>
		</div>

		<div v-else-if="row.amount_usdt">
			<div class="space-y-2">
				<div class="flex items-center space-x-2">
					<UIcon name="i-cryptocurrency-usdt" class="w-5 h-5 text-green-600"/>
					<div class="text-zinc-800 dark:text-zinc-300 font-mono text-lg">{{ locale_float(row.amount_usdt) }}</div>
				</div>
			</div>
		</div>

		<div v-if="row.ax_data?.decrypted_result?.transaction?.transCurrencyAmt && row.ax_data?.decrypted_result?.transaction?.transCurrency !== row.ax_data?.decrypted_result?.transaction?.feeCurrency">
			<span class="font-mono text-zinc-800 dark:text-zinc-300">{{ locale_float(row.ax_data?.decrypted_result?.transaction?.transCurrencyAmt) }}  {{ row.ax_data?.decrypted_result?.transaction?.transCurrency }}</span>
		</div>
	</div>
</template>
